import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {PaymentGatewayService} from "../../../serverService/paymentGatewayService/PaymentGatewayService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoConfirmDialog,
    RaikoGridOneColumn,
    RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";

import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function PaymentGatewayStatus() {

    const {id: gateWayId} = useParams()

    const service = new PaymentGatewayService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof gateWayId !== 'undefined') {
            service.getGatewayEnabled(gateWayId)
                .then(response => {
                    setEnabled(response.enabled)
                    setNewEnabled(response.enabled)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {

            })
        }
    }, [gateWayId]);


    const [enabled, setEnabled] = useState(false)
    const [newEnabled, setNewEnabled] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);

    function handleUpdateState() {
        loading.show()
        service.updateGatewayEnabled(gateWayId, newEnabled)
            .then(response => {
                setEnabled(response.enabled)

                if (response.enabled)
                    showSuccessMessage("درگاه با موفقیت فعال شد")
                else
                    showWarningMessage("درگاه غیرفعال شد")

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
            setOpenDialog(false)
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={openDialog}
                cancelAction={_ => setOpenDialog(false)}
                doAction={handleUpdateState}
                pageTitle={"فعالسازی/ غیرفعالسازی"}
                warningTitle={"آیا از تغییر وضعیت درگاه اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={enabled ? "غیرفعالسازی" : "فعالسازی"}
                cancelButtonTitle={"بیخیال"}
            />
            <RaikoBaseCardContainer className={css`margin-top: 16px;`}>
                <RaikoGridOneColumn>
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            type={raikoAlertTypes.warning}
                            title={"وضعیت فعالسازی درگاه پرداخت"}
                            description={[
                                "* با غیرفعالسازی درگاه تمامی پرداخت ها متوقف خواهد شد.",
                                "* با فعالسازی درگاه امکان پرداخت در تمامی موارد استفاده شده از این درگاه فراهم خواهد شد."
                            ]}
                        />
                        <RaikoToggleOutlined
                            labelText={"فعالسازی درگاه پرداخت"}
                            setChecked={state => {
                                setNewEnabled(state)
                                setOpenDialog(true)
                            }}
                            checked={enabled}
                            id={"requestNewHabitation"}
                        />
                    </RaikoGridOneColumn>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </>
    )
}